export default __webpack_public_path__ + "static/media/email.0e0b609b.svg";